import { getSearchParamValue } from '@/util/helper/searchParams';

import useCallback from '@/util/hook/useCallback';
import useState from '@/util/hook/useState';

import View from './View';

const ENV = process.env.ENV.TARGET_ENV;
const ENTRY_POINT_TRACKER_ID_SEARCH_PARAM = 'epid';
const ALT_LINK_DISPLAY_DELAY_SECOND = 5;

const getRedirectUrl = (entryPointTrackerId: string) => {
  switch (ENV) {
    case 'local':
      return `line://app/1653842352-KE969ZyA?epid=${entryPointTrackerId}`;
    case 'dev':
      return `line://app/1653842352-KE969ZyA?epid=${entryPointTrackerId}`;
    case 'prod':
      return `line://app/1653855654-2WYva4Nr?epid=${entryPointTrackerId}`;
    default:
      throw new Error(`Invalid ENV type: ${ENV} in the getRedirectUrl function`);
  }
};

const redirectToUrl = (redirectUrl: string) => {
  window.location.replace(redirectUrl);
};

export default function Controller() {
  const [shouldRenderAltLink, setShouldRenderAltLink] = useState(false);

  // event handlers
  const handleActionButtonClick = useCallback(() => {
    setTimeout(() => {
      setShouldRenderAltLink(true);
    }, 1000 * ALT_LINK_DISPLAY_DELAY_SECOND);

    const entryPointTrackerId = getSearchParamValue({
      paramKey: ENTRY_POINT_TRACKER_ID_SEARCH_PARAM,
    });
    const redirectUrl = getRedirectUrl(entryPointTrackerId);

    redirectToUrl(redirectUrl);
  }, []);

  return (
    <View
      // data
      shouldRenderAltLink={shouldRenderAltLink}
      // func
      handleActionButtonClick={handleActionButtonClick}
    />
  );
}
